import React, {
  memo
} from "react";
import {
  View,
  StyleSheet,
  Pressable
} from "react-native";
import {
  Feather
} from "@expo/vector-icons";
import {
  Text
} from "@constants/Themed";
import {
  themeSelector
} from "@reduxLocal/selectors/themeSelector";
import {
  WidgetKey,
  WidgetSize
} from "./config";

interface WidgetWrapperProps {
  widgetKey: WidgetKey;
  size: WidgetSize;
  children: React.ReactNode;
  onResize: (key: WidgetKey) => void;
  isMobile: boolean;
  height: number;
}

const WidgetWrapper: React.FC<WidgetWrapperProps> = ({
  widgetKey,
  size,
  children,
  onResize,
  isMobile,
  height,
}) => {
  const theme = themeSelector();

  const handleResize = () => onResize(widgetKey);

  return (
    <View
      style={
        [
          styles.widgetContainer,
          {
            backgroundColor: theme ? "#f9fafb" : "#111827",
            borderColor: theme ? "#e5e7eb" : "#1f2937",
            height,
          },
        ]
      }
    >
      {!isMobile && (
        <Pressable
          onPress={
            handleResize
          }
          style={
            styles.resizeHandle
          }
          accessibilityLabel="Resize widget"
          accessibilityHint="Cycles through small, medium and large heights"
        >
          <
            Feather name="maximize-2"
            size={
              16
            }
            color="#6b7280" />
          <
          Text style={
              styles.resizeLabel
            } > {
              size.toUpperCase()
            } < /Text> <
          /Pressable>
            )
      } <
      View style={
                styles.widgetContentWrapper
              } > {
                children
              } < /View> <
      /View>
              );
  };

              const styles = StyleSheet.create({
                widgetContainer: {
                margin: 10,
              borderRadius: 16,
              padding: 12,
              shadowColor: "#00000033",
              shadowOpacity: 0.1,
              shadowRadius: 8,
              shadowOffset: {
                width: 0,
              height: 4
      },
              elevation: 2,
              position: "relative",
              borderWidth: 1,
              overflow: "hidden",
              flex: 1,
    },
              widgetContentWrapper: {
                flex: 1,
    },
              resizeHandle: {
                position: "absolute",
              right: 12,
              top: 12,
              zIndex: 2,
              backgroundColor: "#ffffff",
              borderRadius: 12,
              paddingHorizontal: 8,
              paddingVertical: 6,
              flexDirection: "row",
              alignItems: "center",
              shadowColor: "#00000022",
              shadowOpacity: 0.15,
              shadowRadius: 3,
              elevation: 3,
    },
              resizeLabel: {
                fontSize: 10,
              fontWeight: "600",
              color: "#4b5563",
              marginLeft: 6,
    },
  });

              export default memo(WidgetWrapper);
